/*

	SKETCH CODE !	

*/
export const mockCSVData = `Date, Supplier, Product, Units, Price, Carbon, Category
2023-01-15, ACME, wooden door, 50, 250, 45, Doors
2023-02-20, Bobs Doors, steel door, 30, 350, 120, Doors
2023-03-10, Carols Carpentry, pine wood planks, 200, 15, 5, Lumber
2023-04-05, ACME, kitchen sink, 25, 180, 85, Fixtures
2023-05-12, Carols Carpentry, hardwood planks, 150, 25, 8, Lumber
2023-06-18, Bobs Doors, wooden door, 40, 230, 40, Doors
2023-07-22, ACME, steel door, 35, 340, 110, Doors
2023-08-30, Carols Carpentry, pine wood planks, 180, 14, 4.5, Lumber
2023-09-14, Bobs Doors, kitchen sink, 20, 175, 80, Fixtures
2023-10-25, ACME, hardwood planks, 120, 24, 7, Lumber
2023-11-08, Carols Carpentry, wooden door, 45, 240, 42, Doors
2023-12-15, Bobs Doors, steel door, 32, 345, 115, Doors
2024-01-10, ACME, wooden door, 55, 255, 46, Doors
2024-02-15, Bobs Doors, steel door, 35, 355, 122, Doors
2024-03-05, Carols Carpentry, pine wood planks, 220, 16, 5.2, Lumber
2024-04-12, ACME, kitchen sink, 28, 185, 87, Fixtures
2024-05-20, Carols Carpentry, hardwood planks, 160, 26, 8.2, Lumber
2024-06-25, Bobs Doors, wooden door, 42, 235, 41, Doors
2024-07-30, ACME, steel door, 38, 345, 112, Doors
2024-08-15, Carols Carpentry, pine wood planks, 190, 15, 4.8, Lumber
2024-09-22, Bobs Doors, kitchen sink, 22, 180, 82, Fixtures
2024-10-30, ACME, hardwood planks, 130, 25, 7.2, Lumber
2024-11-12, Carols Carpentry, wooden door, 48, 245, 43, Doors
2024-12-20, Bobs Doors, steel door, 36, 350, 118, Doors`